let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4ks37")).then(() => parcelRequire('emQB1'));